import './new-room-type.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormRoomType from "../form-room-type/form-room-type";
import { useNewRoomType } from './new-room-type.hook';

export function NewRoomType() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewRoomType();

  return (
    <div id="NewRoomType" className="room-type">
      <HeaderContent
        title={<h1>New Room Type</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormRoomType />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewRoomType;